//@ts-nocheck
import { Box, Button, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { http } from "../../../api/http";
import ImageUpload from "../../../components/ImageUpload";

const VideosForm = ({ data, toggleDrawer }: any) => {
  const [edit, setEdit] = useState(false);
  const [id, setId] = useState();
  const [picDetails, setPicDetails] = useState(null);
  const [editImage, setEditImage] = useState(data?.thumbnail);

  useEffect(() => {
    data && setEdit(true);
    data && setId(data?.id);
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: {
      title: data?.title,
      description: data?.description,
      link: data?.link,
    },
  });

  const queryClient = useQueryClient();

  console.log(data);

  const onSubmit = async (data: any) => {
    if (edit) {
      console.log(id);
      const formData = {
        ...data,
        thumbnail: picDetails?.Location ? picDetails?.Location : editImage,
        type: "VIDEO",
      };
      http
        .patch(`/resources/${id}`, formData)
        .then((res) => {
          toast.success("The video details have been updated");
          queryClient.invalidateQueries("videos");
          toggleDrawer(false);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    } else {
      console.log(data);
      const formData = {
        ...data,
        thumbnail: picDetails?.Location ? picDetails?.Location : editImage,
        type: "VIDEO",
      };
      http
        .post(`/resources`, formData)
        .then((res) => {
          toast.success("The video has been created");
          queryClient.invalidateQueries("videos");
          toggleDrawer(false);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    }
    console.log(data);
  };
  return (
    <div>
      {" "}
      <Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <TextField
            type={"text"}
            {...register("title", {
              required: true,
            })}
            label={"Headline"}
            required={true}
            fullWidth={true}
            variant={"standard"}
            sx={{ marginTop: "24px" }}
          />
          {errors?.title?.type == "required" && (
            <Typography sx={{ color: "red" }}>
              This field is required
            </Typography>
          )}
          <TextField
            multiline
            maxRows={2}
            {...register("description", {
              required: true,
            })}
            label={"Description"}
            required={true}
            fullWidth={true}
            variant={"standard"}
            sx={{ marginTop: "24px" }}
          />
          {errors?.description?.type == "required" && (
            <Typography sx={{ color: "red" }}>
              This field is required
            </Typography>
          )}
          <TextField
            type={"text"}
            {...register("link", {
              required: true,
              pattern: {
                value: /^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/,
              },
            })}
            label={"Video Link"}
            required={true}
            fullWidth={true}
            variant={"standard"}
            sx={{ marginTop: "24px" }}
          />
          {errors?.link?.type == "required" && (
            <Typography sx={{ color: "red" }}>
              This field is required
            </Typography>
          )}
          {errors?.link?.type == "pattern" && (
            <Typography sx={{ color: "red" }}>Invalid Link</Typography>
          )}
          <ImageUpload
            picDetails={picDetails}
            setPicDetails={setPicDetails}
            editImage={editImage}
            setEditImage={setEditImage}
            title={"thumbnail"}
          />
          <Button type="submit" variant="contained" sx={{ marginTop: "24px" }}>
            {data ? "Edit Video" : "Submit Video"}
          </Button>
        </form>
      </Box>
    </div>
  );
};

export default VideosForm;
